export default {
      id: "settings-jobsites-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite-46b249.svg#settings-jobsites-usage",
      toString: function () {
        return this.url;
      }
    }